import React from 'react';
import './estilos.css';

function QuienesSomos() {
    return (
        <div className='cont-quienesSomos'>
            <p className='parrafo-quienesSomos'>
                Desde 1986, en Especiera del Sol trabajamos con especias y 
                frutas secas de primera calidad, 
                con excelencia y dedicación. 
                Contamos con producción propia en el norte argentino 
                y trabajamos con los mejores importadores para brindarles a nuestros clientes 
                productos especialmente seleccionados.
            </p>
        </div>
    )
}

export default QuienesSomos